<template>
  <v-row class="actions">
    <v-col>
      <slot></slot>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Actions',
  }
</script>

<style scoped>
.actions {
  background-color: #f3f3f3;
}
</style>
